import { useEffect, useState } from "react";
import { TextField, Theme, SxProps } from "@mui/material";
import StyledAutocomplete from "components/StyledAutocomplete";
import useDebounce from "helpers/useDebounce";
import { runGqlQuery } from "gqlClient";
import { SearchCasesResult, SearchLensCasesDocument } from "generated/graphql";
import { useSnackbar } from "notistack";

interface CaseTableFilterByAssigneeProps {
  label: string;
  selection: string | undefined;
  setSelection: (s: string | undefined) => void;
  sx?: SxProps<Theme>;
  lensId: number;
  assigneeId: number;
}
const CaseTableFilterByAssignee = (props: CaseTableFilterByAssigneeProps) => {
  const { label, selection, setSelection, sx, lensId, assigneeId } = props;
  const [prefixQuery, setPrefixQuery] = useState<string>("");
  const prefixQueryDebounced = useDebounce(prefixQuery, 200);
  const [options, setOptions] = useState<SearchCasesResult[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (prefixQueryDebounced) {
      runGqlQuery(SearchLensCasesDocument, { lensId, assigneeId, query: prefixQueryDebounced, limit: 20 })
        .then((results) => {
          setOptions(results.lens.searchCases || []);
        })
        .catch((error) => {
          console.error("Error searching lens cases", error);
          enqueueSnackbar("Error searching lens cases", { variant: "error" });
        });
    }
  }, [prefixQueryDebounced, lensId, assigneeId]);

  return (
    <StyledAutocomplete
      sx={sx || {}}
      id="case-filters"
      data-pendo="case-filter-assignee"
      size="small"
      fullWidth
      autoComplete
      filterOptions={(x) => x}
      autoHighlight
      freeSolo
      value={selection === undefined ? "" : selection}
      onInputChange={(_evt, v) => {
        setPrefixQuery(v);
      }}
      onChange={(_evt, v) => {
        if (v === null) {
          setSelection(undefined);
        } else if (typeof v === "string") {
          setSelection(v as string);
        } else {
          setSelection((v as any).claimantName);
        }
      }}
      options={options}
      getOptionLabel={(f) => {
        if (typeof f === "string") {
          return f;
        } else {
          return `${f.claimantName} (${f.clientCaseId})`;
        }
      }}
      renderInput={(params) => <TextField {...params} label={label} fullWidth />}
    />
  );
};

export default CaseTableFilterByAssignee;
